import React, { Component, useState } from 'react';
import EventController from '../../controllers/EventController'
import CreateEventCommand from '../../models/events/createEventCommand'
import { useForm } from "react-hook-form";
import PacmanLoader from "react-spinners/PacmanLoader";

interface IProps{
    reload:any
}

interface IState{
    loading:boolean
}
export default function CreateEvent(props: IProps) {
    const { register, handleSubmit } = useForm<CreateEventCommand>();
    const [loading, setLoading]= useState(false);
    const {reload} = props;

    const onSubmit = async (data: CreateEventCommand) => {
        if(!data.RewardsLoyalty){
            data.RewardsLoyalty = false;
        }
        setLoading(true)
        var eventController = new EventController();
        var result = await eventController.CreateEvent(data);
        if(result){
            console.log(result)
            reload();
        }
    };
    if(loading)
    {
        return <div className="col-6 mx-auto text-center"><PacmanLoader color="#947a27" /></div>
    }
    return (
        <div className="col-6 mx-auto">
            <h1 className="text-center">Create Event</h1>
            <br />
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input type="text" className="form-control" {...register("Name")} />
                </div>
                <div className="mb-3">
                    <label className="form-label">Hosts</label>
                    <input type="text" className="form-control" {...register("Hosts")} />
                </div>
                <div className="mb-3 form-check">
                    <input type="checkbox" className="form-check-input" {...register("RewardsLoyalty")} />
                    <label className="form-check-label">Rewards Loyalty?</label>
                </div>
                <button type="submit" className="btn btn-lg btn-light">Submit</button>
            </form>
        </div>
    );
}
